import { AuthenticationService } from '@treasury/domain/services/authentication';
import { ActionResult, Commands, RouteContext } from '@vaadin/router';

export async function pageEnabled(
    context: RouteContext,
    commands: Commands,
    pathRedirect?: string
): Promise<ActionResult | undefined> {
    const token = sessionStorage.getItem('Jha-Treasury-JhaAuthToken');
    let isAuthenticated = false;
    if (context.pathname.includes('terms-and-conditions')) {
        isAuthenticated = !!token;
    } else {
        const termsAndConditions = sessionStorage.getItem('termsAndConditions');
        isAuthenticated = !!token && !!termsAndConditions;
    }

    const authService = await AuthenticationService.getInstance();
    if (!isAuthenticated) {
        authService.invalidate();
        // eslint-disable-next-line no-console
        console.warn('User not authorized', context.pathname);
        return commands.redirect(pathRedirect || '/');
    }

    if (!authService.authenticated) {
        authService.authenticate();
    }

    return undefined;
}
